<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      FormErrorAlert(heading="Error"
                      :message="message"
                      v-show="message"
                      @dismiss="message = ''")
      h1 Edit Personal Information
      form(autocomplete="off")
        AccountSection.mt-4(message="PERSONAL INFORMATION" required)
          AdminEditPersonalInfo(
            :edit-primary-email="true"
            :username.sync="username"
            :firstName.sync="firstName"
            :middleName.sync="middleName"
            :lastName.sync="lastName"
            :title.sync="title"
            :email.sync="email"
            :altEmail1.sync="altEmail1"
            :altEmail2.sync="altEmail2"
            :workPhone.sync="workPhone"
            :superFirstName.sync="superFirstName"
            :superMiddleName.sync="superMiddleName"
            :superLastName.sync="superLastName"
            :superRank.sync="superRank"
            :superEmail.sync="superEmail"
            :superPhone.sync='superPhone'
            :notes.sync="notes"
            :firstNameInvalid="firstNameInvalid"
            :lastNameInvalid="lastNameInvalid"
            :emailInvalid="emailInvalid || emailIfInvalid || emailInUse"
            :emailError="emailError"
            :altEmail1Invalid="altEmail1IfInvalid"
            :altEmail2Invalid="altEmail2IfInvalid"
            :phoneFormatInvalid="phoneFormatInvalid"
            :superEmailIfInvalid="superEmailIfInvalid"
            :superPhoneFormatInvalid="superPhoneFormatInvalid"
            @save="save"
            @cancel="cancel"
          )
</template>

<script>
import {
  mapTouched,
  mapRequired,
  mapRequiredIf,
  validationHelpers,
  phoneNumberValidators,
} from '@/lib/validation'
import AccountSection from '@/components/AccountSection'
import AdminEditPersonalInfo from '@/components/AdminEditPersonalInfo'
import stdmsg from '@/lib/stdmsg'
import { getUserInfo, updateUserInfo } from '@/lib/services/useradmin'
import { globalSuccess, extractMessage } from '@/lib/utils'

export default {
  name: 'AdminEditProfile',
  data() {
    return {
      message: '',
      username: '',
      firstName: '',
      lastName: '',
      middleName: '',
      title: '',
      email: '',
      oldEmail: '',
      altEmail1: '',
      altEmail2: '',
      workPhone: '',
      superFirstName: '',
      superMiddleName: '',
      superLastName: '',
      superRank: '',
      superEmail: '',
      superPhone: '',
      notes: '',
      emailInUse: false,
      ...mapTouched([
        'lastName',
        'firstName',
        'email',
        'altEmail1',
        'altEmail2',
        'workPhone',
        'superFirstName',
        'superLastName',
        'superRank',
        'superEmail',
        'superPhone',
      ]),
    }
  },
  components: {
    AccountSection,
    AdminEditPersonalInfo,
  },
  methods: {
    ...validationHelpers(),
    save() {
      this.markAllTouched()
      this.emailInUse = false
      const anyInvalid =
        this.firstNameInvalid ||
        this.lastNameInvalid ||
        this.emailInvalid ||
        this.emailIfInvalid ||
        this.altEmail1IfInvalid ||
        this.altEmail2IfInvalid ||
        this.phoneFormatInvalid ||
        this.superEmailIfInvalid ||
        this.superPhoneFormatInvalid
      if (anyInvalid) {
        this.message = stdmsg.formError
        scrollTo(0, 0)
        return
      }

      updateUserInfo({
        id: this.$route.query.id,
        username: this.username,
        firstName: this.firstName,
        lastName: this.lastName,
        middleName: this.middleName,
        title: this.title,
        altEmail1: this.altEmail1,
        altEmail2: this.altEmail2,
        workPhone: this.formattedWorkPhone,
        supervisorFirstName: this.superFirstName,
        supervisorLastName: this.superLastName,
        supervisorMiddleName: this.superMiddleName,
        supervisorRank: this.superRank,
        supervisorEmail: this.superEmail,
        supervisorPhone: this.formattedSuperPhoneNumber,
        notes: this.notes,
        oldEmail: this.oldEmail,
        email: this.email,
      })
        .then(() =>
          this.$router.push({
            name: 'user_search_view',
            query: { id: this.$route.query.id },
          }),
        )
        .then(() =>
          globalSuccess(null, 'User information was successfully updated.'),
        )
        .then(() => scrollTo(0, 0))
        .catch(err => {
          scrollTo(0, 0)
          this.emailInUse = true
          this.message = extractMessage(err)
        })
    },
    cancel() {
      this.$router.push({
        name: 'user_search_view',
        query: { id: this.$route.query.id },
      })
    },
  },
  computed: {
    ...mapRequired(['lastName', 'firstName', 'email']),
    ...mapRequiredIf(['email', 'altEmail1', 'altEmail2', 'superEmail'], x =>
      /[^@]+@.+\..+/.test(x),
    ),
    ...phoneNumberValidators('workPhone'),
    ...phoneNumberValidators('superPhone', 'superPhoneFormatInvalid'),
    formattedWorkPhone() {
      return this.workPhone.replace(/[^\d]/g, '')
    },
    formattedSuperPhoneNumber() {
      if (this.superPhone){
        return this.superPhone.replace(/[^\d]/g, '')
      } else {
        return ''
      }
    },
    emailError() {
      return this.emailInUse
        ? 'This email is in use by another user.'
        : stdmsg.emailError
    },
  },
  beforeRouteEnter(to, _from, next) {
    getUserInfo(to.query.id).then(resp =>
      next(vm => {
        Object.keys(resp.data).forEach(k => (vm[k] = resp.data[k]))
        vm.oldEmail = resp.data.email
        vm.superFirstName = resp.data.supervisorFirstName
        vm.superMiddleName = resp.data.supervisorMiddleName
        vm.superLastName = resp.data.supervisorLastName
        vm.superRank = resp.data.supervisorRank
        vm.superEmail = resp.data.supervisorEmail
        vm.superPhone = resp.data.supervisorPhone
      }),
    )
  },
}
</script>

<style lang="scss" scoped>
</style>
